require('normalize.css/normalize.css');
require('../css/global.scss');
require('./page.scss');

require('../img/favicon.ico');

let version = "0.9.6";
let downloadWinUrl = "https://metricat-storage.s3-ap-northeast-1.amazonaws.com/Metricat-win-" + version + ".exe";
let downloadMacUrl = "https://metricat-storage.s3-ap-northeast-1.amazonaws.com/Metricat-mac-" + version + ".dmg";
let downloadDebUrl = "https://metricat-storage.s3-ap-northeast-1.amazonaws.com/Metricat-deb-" + version + ".deb";
let downloadRpmUrl = "https://metricat-storage.s3-ap-northeast-1.amazonaws.com/Metricat-rpm-" + version + ".rpm";

// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyCWatiG9IeS_JVxlsNEZL8r7wG5CuHSUaU",
  authDomain: "metricat-de3b0.firebaseapp.com",
  databaseURL: "https://metricat-de3b0.firebaseio.com",
  projectId: "metricat-de3b0",
  appId: "1:673729961116:web:3237490cbb5d9f80dbe159",
  measurementId: "G-K52LZMZ1KN"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

window.subscribe = function subscribe() {
  const email = document.getElementById("subscription_email").value;
  if (email != "" && validateEmail(email)) {
    submitEmail(email)
      .then(function (docRef) {
        console.log("Document written with ID: ", docRef.id);
        document.getElementById("subscription-form").style.display = "none";
        document.getElementById("subscription-finished").style.display = "block";
      });
  }
}

function submitEmail(email) {
  var db = firebase.firestore();
  return db.collection("users")
    .add({
      email: email,
      time: new Date()
    })
    .catch(function (error) {
      console.error("Error adding document: ", error);
    });
}

function validateEmail(email) {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

function runAutomaticDownload(env, downloadUrl) {
  setTimeout(function () {
    gtag('event', 'download', { 'event_category': 'download-auto-' + env, 'event_label': version });
    usergram.push(['send','Ugo97x-1','event','metricat_download_ + env' + env]);
    window.location = downloadUrl;
  }, 100);
}

if (window.location.hash == '#auto-win') {
  runAutomaticDownload('win', downloadWinUrl);
} else if (window.location.hash == '#auto-mac') {
  runAutomaticDownload('mac', downloadMacUrl);
} else if (window.location.hash == '#auto-deb') {
  runAutomaticDownload('deb', downloadDebUrl);
} else if (window.location.hash == '#auto-rpm') {
  runAutomaticDownload('rpm', downloadRpmUrl);
}

window.directDownload = function (os) {
  gtag('event', 'download', { 'event_category': 'download-direct-' + os, 'event_label': version });
  usergram.push(['send','Ugo97x-1','event','metricat_download_' + os]);
}


